
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api"
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { changeStatus } from "slices/subUserSlice";
import AddSubUsers from "components/subUsers/AddSubUsers";
import { subUserSelector } from "slices/subUserSlice";
import { fetchSubUsers } from "slices/subUserSlice";
import { removeMultipleSubUsers } from "slices/subUserSlice";

const apiService = new Api();

function PermissionSubUser() {
  const dispatch = useDispatch()
  const { subUser, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(subUserSelector);

  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}
  });

  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10])
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });



  React.useEffect(() => {
    dispatch(fetchSubUsers())
  }, [])

  const handleAddLanguagePopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchSubUsers())
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleRemoveItems = () => {
    dispatch(removeMultipleSubUsers({ ids: selectedItems }, submitCallback))
  }
  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(subUser?.map((val) => val.id.toString()))
  }

  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    dispatch(fetchSubUsers(page));
  }, [])

  const handleClose = () => {
    // refAddutton.current.click(); 
    setAddForm({ show: false })
  };

  const handleSelect = (value) => {
    setSelectedValue(value)

  }


  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {

    const callBack = (dir, sortBy) => {

      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchSubUsers(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }
    return (
      <tr>
        <th>
          <div className="row_check">
            <span>#</span>
            <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
          </div>
        </th>
        <th>

          <TableHeaderItem
            title="Name"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title="Permission Group"
            sortBy="permission_group"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Email"
            sortBy="email"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title="Gender"
            sortBy="gender"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="phone"
            sortBy="phone"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {/* <th>
          <TableHeaderItem
            title="Role"
            sortBy="role"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th> */}
        <th >Actions</th>
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      subUser?.map((item, index) => (
        <SubUserItem data={item} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddLanguagePopUp} current_page={current_page} pageLength={pageLength} />
      ))
    )
  }, [subUser, selectedItems]);

  //#endregion

  const renderAddButton = () => {
    return (
      <button
        type="button"
        className="main_button ml-4"
        onClick={handleAddLanguagePopUp}
        autoFocus
      >
        {"Add Tiers"}
      </button>
    )
  }


  return (
    <ListLayout
      heading="Sub Users"
      time={true}
      title=""
      buttonTitle="Add sub user"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      fetchList={fetchSubUsers}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      renderAddForm={(callback) => <AddSubUsers item={addForm.item} show={addForm.show} onClose={handleClose} callback={callback} />}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddLanguagePopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      disableBootstrap
      noOfItems={total}
      searchPlaceholder="Search sub users ..."
    >

      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
    </ListLayout>
  )

}


const SubUserItem = ({
  data, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(data?.status == 1 ? 1 : 0 || 0);

  React.useEffect(() => {
    setStatus(data?.status == 1 ? 1 : 0 || 0)

  }, [data])
  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }
  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#f4f4f4' } : {};
  };

  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);
  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          <label className="custom-checkbox checkbox">
            <input type="checkbox" name="select-all" data-value={data.id} checked={selectedItems.includes(data.id.toString())} onChange={handleChange} />
            <span className="checkmark"></span>
          </label>
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>
        {data?.user?.name}
      </td>
      <td style={getBackgroundStyle(status)}>
        {data?.group?.name}
      </td>
      <td style={getBackgroundStyle(status)}>
        {data?.user?.email}
      </td>
      <td style={getBackgroundStyle(status)}>
        {data?.gender}
      </td>
      <td style={getBackgroundStyle(status)}>
        {data?.phone}
      </td>
      {/* <td style={getBackgroundStyle(status)}>
        {data?.user?.role}
      </td> */}
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <button className="table_edit" onClick={() => handleAddPopUp({ ...data, status })}>Edit</button>
          <CustomSwitch handleChange={(status) => handleStatusChange(data?.id, status)} checked={status == 1 ? true : false} />
        </div>
      </td>
    </tr>
  )
}

export default PermissionSubUser